export default __webpack_public_path__ + "a04292ddf99207fdcea0e80b72cfa346.png";